module.exports = __webpack_public_path__ + "img/ECS_LOGO_GROUP.5d738009.png";